class Messager {
  constructor() {
    this.subscribers = new Map();
  }

  subscribe(topic, fn) {
    let list = this.subscribers.get(topic);
    if (!list)
      list = [];

    list.push(fn);

    this.subscribers.set(topic, list);
  }

  unsubscribe() {
    
  }

  publish(topic, info) {
    const list = this.subscribers.get(topic)
    if (!list)
      return;

    for (let fn of list) {
      fn(info);
    }
  }
}

export default Messager;


// WEBPACK FOOTER //
// ./src/components/SqTasks/task/Messager.js